import { Component, h, Prop, ComponentInterface } from '@stencil/core';
import Modal from 'bootstrap/js/src/modal';

@Component({
  tag: 'st-modal-lightbox',
  styleUrl: 'st-modal-lightbox.scss',
  shadow: false,
})
export class StModalLightbox implements ComponentInterface {

	/**
	 * Assigns a required unique id to the general modal
	 */
	@Prop() modalId: string = "lightboxModal";

	componentDidLoad() {
		let modalElement = document.getElementById(this.modalId);
		new Modal(modalElement);

		// Leverages Bootstrap's Modal JS to create lightbox for content
		modalElement.addEventListener('show.bs.modal', function(event: MouseEvent) {

			let button = event.relatedTarget as Element;
			let content = button.nextElementSibling.innerHTML;
			let modalContent = modalElement.querySelector('.modal-content');

			modalContent.innerHTML = content;

			let videoItems = modalContent.querySelectorAll('[data-src]');

			// Move iframe/video data source values into src.
			// Prevents that content from loading until modal is opened.
			videoItems.forEach((item: HTMLIFrameElement) => {
				item.src = item.getAttribute('data-src');
			});

			let firstFocusable = modalElement.querySelector('.btn-close') as HTMLButtonElement;
			let lastFocusable = modalElement.querySelector('.btn-link.visually-hidden-focusable') as HTMLInputElement;
			
			// Set focus on first focusable item in modal
			modalElement.addEventListener('shown.bs.modal', function() {
				firstFocusable.focus();
			});

			// If reverse tabbing go to end of modal
			firstFocusable.addEventListener('keydown', function(event) {
				if ((event.key === 'Tab' || event.code === 'Tab') && event.shiftKey) {
					event.preventDefault();
					lastFocusable.focus();
				}
			});

			// If tabbing at end of modal, return back to beginning
			lastFocusable.addEventListener('keydown', function(event) {
				if ((event.key === 'Tab' || event.code === 'Tab') && !event.shiftKey ) {
					event.preventDefault();
					firstFocusable.focus();
				}
			});

		});

		modalElement.addEventListener('hide.bs.modal', function() {
			let modalContent = modalElement.querySelector('.modal-content');
			modalContent.innerHTML = '';
		});
	}

	render() {
		
		return (
			<div class="modal modal-lightbox fade" id={this.modalId} aria-label="Lightbox" aria-hidden="true" tabindex="-1">
				<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<slot />
					</div>
				</div>
				<button type="button" class="btn btn-link text-white visually-hidden-focusable" aria-label="Close" data-bs-dismiss="modal">Close Modal</button>
			</div>
		);
	}
}